import React from 'react'

const PlaneIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="plane-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 200, 255, 1)" />
          <stop offset="100%" stopColor="rgba(150, 100, 255, 1)" />
        </linearGradient>
        <filter id="plane-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" 
        stroke="url(#plane-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        filter="url(#plane-glow)"
      />
      <circle cx="22" cy="2" r="1.5" fill="url(#plane-gradient)" opacity="0.8" />
      <circle cx="11" cy="13" r="1" fill="url(#plane-gradient)" />
      <path 
        d="M8 16L6 18L4 16" 
        stroke="url(#plane-gradient)" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        opacity="0.6"
      />
    </svg>
  )
}

export default PlaneIcon
